import { UnthaState } from "./_types";

export const DEFAULT_STATE: UnthaState = {
    fetching: false,
    error: false,
    data: null,
    filteredData: [],
  }